"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTestId = getTestId;
exports.getTestIdProps = getTestIdProps;
exports.isBreakingLine = isBreakingLine;
exports.isLottieAnimation = isLottieAnimation;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var FONT_SIZE = '14px';
var FONT_FAMILY = 'ProximaNova,Arial,sans-serif';
var FONT_WEIGHT = '400';

// https://stackoverflow.com/questions/34204975/react-is-there-something-similar-to-node-textcontent#:~:text=const%20getNodeText%20%3D%20(,return%20%27%27%0A%20%20%7D%0A%7D
var _getNodeText = function getNodeText(node) {
  if (node == null) {
    return '';
  }
  switch ((0, _typeof2["default"])(node)) {
    case 'string':
    case 'number':
      return node.toString();
    case 'boolean':
      return '';
    case 'object':
      {
        if (node instanceof Array) {
          return node.map(_getNodeText).join('');
        }
        if ('props' in node) {
          return _getNodeText(node.props.children);
        }
      }
    default:
      return '';
  }
};
function isBreakingLine(text, containerElement) {
  var textString = _getNodeText(text);
  // Creating a test element for the text length
  var testElement = document.createElement('div');

  // Set the styling to match the style of the text we mimic
  testElement.style.fontSize = FONT_SIZE;
  testElement.style.fontFamily = FONT_FAMILY;
  testElement.style.fontWeight = FONT_WEIGHT;

  // Set the width of the element to match the width of the text container
  testElement.style.width = "".concat(containerElement.getBoundingClientRect().width, "px");
  testElement.style.opacity = '0';

  // Appending to body in order to render the text
  document.body.appendChild(testElement);

  // Setting short text to have the original height value
  testElement.innerHTML = 'I';
  var originalHeight = testElement.getBoundingClientRect().height;

  // Setting the desired text and messure the height once again
  testElement.innerHTML = textString;
  var heightWithText = testElement.getBoundingClientRect().height;

  // Removing from body
  document.body.removeChild(testElement);
  return originalHeight < heightWithText;
}
function isLottieAnimation(mediaPath) {
  return (0, _typeof2["default"])(mediaPath) === 'object';
}
function getTestIdProps(_ref) {
  var testId = _ref.testId,
    testIdName = _ref.testIdName,
    suffix = _ref.suffix;
  return {
    testId: getTestId(testId, suffix),
    testIdName: getTestId(testIdName, suffix)
  };
}
function getTestId(testId, name) {
  return testId ? "".concat(testId, "-").concat(name) : undefined;
}
//# sourceMappingURL=utils.js.map